module.exports = __webpack_public_path__ + "img/cheerup.ffea666a.png";